import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */

 export function getCcfInfo(obj: any) {
  return request({
    url: '/mcn/detail',
    method: 'get',
    params: obj,
  })
}
export function getRecInfo(obj: any) {
  return request({
    url: '/getMcnNewsListApi',
    method: 'post',
    data: obj,
  })
}
export function getChexing(obj: any) {
  return request({
    url: '/getMyClubSeriesAPI',
    method: 'get',
    params: obj,
  })
}
export function getIndexCjType(obj: any) {
  return request({
    url: '/report/list',
    method: 'get',
    params: obj,
  })
}
export function getRecommendData(obj: any) {
  return request({
    url: '/app/getRecommendCar',
    method: 'get',
    params: obj,
  })
}
export function getHeaderData(obj: any) {
  return request({
    url: '/chf/focusMap/list',
    method: 'get',
    params: obj,
  })
}
